/**
 * Initialisiert alle Filter-Dropdowns inklusive Öffnen, Schließen
 * und Tastaturnavigation innerhalb der Optionen.
 */
export function initDropdowns() {
    const filters = document.querySelectorAll(".filter");
    if (!filters.length) return;

    filters.forEach((filter) => {
        const toggle = filter.querySelector(".filter__toggle");
        const panel = filter.querySelector(".filter__panel");
        if (!toggle || !panel) return;

        const inputs = [...panel.querySelectorAll("input")];

        toggle.addEventListener("click", (e) => {
            e.stopPropagation();
            closeAll(filters, filter);
            filter.classList.toggle("filter--open");
        });

        panel.addEventListener("keydown", (e) => {
            const i = inputs.indexOf(document.activeElement);
            if (i === -1) return;

            if (e.key === "ArrowDown") inputs[i + 1]?.focus();
            if (e.key === "ArrowUp") inputs[i - 1]?.focus();
            if (e.key === "Home") inputs[0]?.focus();
            if (e.key === "End") inputs.at(-1)?.focus();

            if (e.key === "Escape") {
                filter.classList.remove("filter--open");
                toggle.focus();
            }
        });
    });

    document.addEventListener("click", () => {
        filters.forEach((filter) => filter.classList.remove("filter--open"));
    });
}

/**
 * Schließt alle geöffneten Dropdowns außer dem optional übergebenen Element.
 */
function closeAll(filters, except = null) {
    filters.forEach((filter) => {
        if (filter !== except) {
            filter.classList.remove("filter--open");
        }
    });
}